<template>
    <div class="slides__slide slider grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-12">
                <div class="text-content">
                    <div class="stepCounter">
                        <span class="stepCounter__from">{{ slidedata.step }}</span>
                        <span class="stepCounter__to">{{ slidedata.stepOf }}</span>
                    </div>

                    <h1>{{ slidedata.title }}</h1>
                    <p v-html="slidedata.text" />
                </div>

                <div class="center">
                    <div class="range-slider-container">
                        <div class="range-slider-wrapper">
                            <VueRangeSlider
                                tooltip="always"
                                :min="slidedata.min"
                                :max="Math.ceil(slidedata.max)"
                                :step="1"
                                v-model="model"
                                :height="2"
                                :dot-width="44"
                                :dot-height="44"
                                :dot-size="22"
                            />
                        </div>

                        <div class="output"><span>{{ niceModel }}</span> {{ $appdata.translations.meter }}</div>
                    </div>

                    <br/><br/>
                    <button class="btn" @click="nextStep()">{{ slidedata.button }}<i class="icon-arrow-right"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueRangeSlider from 'vue-range-slider';

export default {
    components: {
        VueRangeSlider,
    },
    data() {
        return {
            model: this.slidedata.min,
        };
    },
    props: {
        slidedata: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    methods: {
        available(available) {
            if (!available) {
                return window.translations.notAvailable;
            }

            return '';
        },
        nextStep() {
            this.$emit('nextStep', {
                [this.slidedata.name]: this.niceModel,
            });
        },
    },
    computed: {
        niceModel() {
            return Math.min(this.slidedata.max, this.model);
        },
    },
};
</script>
